import { render, staticRenderFns } from "./Shelf.vue?vue&type=template&id=491808de&"
import script from "./Shelf.vue?vue&type=script&lang=ts&"
export * from "./Shelf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports